import styled from 'styled-components';
// import { COLORS } from './../../../../utils/styles/Constants';

const SelectItemWrapper = styled.li.attrs((props) => ({
    className: props.className
}))`
    
`;

export default SelectItemWrapper;